module.exports = __webpack_public_path__ + "img/epigraphdb-logo-white.bee1f15a.png";